// extracted by mini-css-extract-plugin
export default {"list12":"index_list12_n-yYS","pt12":"index_pt12_7NF3v","videoBtn2":"index_videoBtn2_44d3f","pic":"index_pic_RXgDI","videoZz2":"index_videoZz2_Q-qsy"};